import * as Yup from 'yup';

import { Input } from '../../../../../../components/Input/Input';
import { useBankDetails } from '../../useBankDetails.hook';

export const BankAccountSortCodeInputs = ({
  accountNumberName,
  sortCodeName,
}: {
  accountNumberName: string;
  sortCodeName: string;
}) => {
  const { bankAccountNumber, sortCode } = useBankDetails();

  return (
    <>
      <Input
        name={accountNumberName}
        label="Bank account number"
        placeholder="Bank account number"
        disabled={!!bankAccountNumber}
      />
      <Input
        name={sortCodeName}
        placeholder="Sort code"
        label="Sort code"
        disabled={!!sortCode}
      />
    </>
  );
};

// Validation Helpers
export const validateBankAccountNumber = () =>
  Yup.string()
    .test('is-accountNumber', 'Not a valid account number', (value) =>
      Boolean(value && value.length === 8 && !isNaN(Number(value))),
    )
    .required('Required');

export const validateSortCode = () =>
  Yup.string()
    .test('is-sortCode', 'Not a valid sort code', (value) => {
      if (!value) return true;
      const valueAsString = value.replace(/-/g, '');
      return !isNaN(Number(valueAsString)) && valueAsString.length === 6;
    })
    .required('Required');
